module.exports = __webpack_public_path__ + "media/images/pic/saska/saska_teenagers-4fb716ed59cc55afedd52345e00d6ad2.png";